/**
 * Compte comptable
 */
export class Compte {
	numero: string;
	libelle: string;
	type: TypeCompte;

	constructor(dto?: any) {
		if (dto) {
			Object.assign(this,dto);
		}
	}
}

/**
 * Compte comptable avec affichage spécifique
 */
export class DisplayCompte extends Compte {
	displayName: string;

	constructor(dto?: any) {
		super(dto);
		this.updateDisplayName();
	}

	/**
	 * Mise à jour de l'affichage
	 */
	updateDisplayName(): void {
		this.displayName = `${this.numero} - ${this.libelle}`;
	}
}

/**
 * Énumération des types de comptes
 */
export enum TypeCompte {
	NON_DEFINI,
	COMPTE_TIERS,
	COMPTE_TAXE,
	COMPTE_BANQUE,
	COMPTE_CHARGE,
	PERTE_GAIN_CHANGE
}